import { Trans, useTranslation } from 'react-i18next';
import { BroadcastChannel } from 'broadcast-channel';
import { useEffect, useState } from 'react';
import OpenSeaDragon from 'openseadragon';
import './imageViewer.css'

export const ImageViewerPage = () => {
  const { t } = useTranslation();
  const channel = new BroadcastChannel('imageViewer-channel');
  const [images, setImages] = useState("") // List of images to be displayed
  const [numberOfPages, setNumberOfPages] = useState(0) // Total number of images / pages
  const id: string = "LEAF-Wwriter-SepImageViewer"
  const [pageNumber, setPageNumber] = useState(1) // Nr of currently displayed image / page

  // Handling incomming broadcast messages, which are used to communicate with the main window
  useEffect(() => {
    const handleMessage = (event) => {
      // When getting a set of (new) images do display, update the state component. If the state component has not been empty, images have already been displayed,
      // therefore the page has to be reloaded entirely, because otherwise OpenSeaDragon misfunctions
      if (event.tileSources) {
        if (images != "") window.location.reload(); // If images have not been empty, force re-load to completely re-initialize OSD
        setImages(event.tileSources);
      }
      // Answer to question, if external image viewer is already open. Feature currently not used, but may be useful in the future?
      if (event.question && event.question == "isOpen?") {
        channel.postMessage({answer: true})
      }
    };

    channel.onmessage = handleMessage;

    // Clean up the channel when the component unmounts
    return () => {
        channel.close();
    };
  }, [channel]);

  // Signal to main window that imageViewer is ready to receive a set of images
  useEffect(() => {
    channel.postMessage({imageViewerWindowReady: true})
  }, [])

  // Update window title so user can differentiate it from the main LEAF-Writer window
  useEffect(() => {
    document.title = "LEAF-Writer Image Viewer"
  }, [])

  // Update total number of images
  useEffect(() => {
    setNumberOfPages(images.length)
  }, [images])

  // On change of images state, initialize the OpenSeaDragon Viewer
  useEffect(() => {
    var viewer;
    if (!viewer) {
      viewer = OpenSeaDragon({
        id: 'seadragon-viewer',
        sequenceMode: true,
        autoHideControls: false,
        showFullPageControl: false,
        previousButton: `${id}_prev`,
        nextButton: `${id}_next`,
        zoomInButton: `${id}_zoomIn`,
        zoomOutButton: `${id}_zoomOut`,
        homeButton: `${id}_home`,
      });
    }

    // Try to re-load the images to reset OSD in order to display the right number of images
    viewer.close();
    viewer.tileSources = []; // hack to remove any previously added images
    viewer.open(images)

    // update the currently displayed page state for the text "x / y" images
    viewer.addHandler('page', (event: any) => {
      setPageNumber(event.page + 1);
    });

    // Cleanup (equal to componentWillUnmount)
    return () => {
      viewer.destroy();
      viewer = null;
    };
  }, [images]);

  return (
    <div id={id} className="imageViewer">
        <div className="toolbar">
          <div className="navigation">
            <span id={id + "_prev"} className="lw-button">
              <i className="fas fa-arrow-left"></i>
            </span>
            <span id={id + "_next"} className="lw-button">
              <i className="fas fa-arrow-right"></i>
            </span>
            <span className="pageInfo">
              <span className="currPage">{pageNumber}</span> / <span className="totalPages">{numberOfPages}</span>
            </span>
          </div>
          <div className="zoom">
            <span id={id + "_zoomIn"} className="lw-button">
              <i className="fas fa-search-plus"></i>
            </span>
            <span id={id + "_zoomOut"} className="lw-button">
              <i className="fas fa-search-minus"></i>
            </span>
            <span id={id + "_home"} className="lw-button">
              <i className="fas fa-compress"></i>
            </span>
          </div>
        </div>
        <div id="seadragon-viewer" className="image" />
      </div>
  );
};
